import newDropdown from "../../../../src/images/new-dropdown.png";
import versionSwitcher from "../../../../src/images/version-switcher.png";
import { Alert } from '@cmsgov/design-system';
import * as React from 'react';
export default {
  newDropdown,
  versionSwitcher,
  Alert,
  React
};